import * as queryString from "query-string";

export type IQueryValue = string | string[] | number | number[] | boolean | undefined;
export type IQuery = Record<string, IQueryValue>;

export const appendQueryString = (currentUrl: string, inputQuery: IQuery): string => {
    const {"": omit, ...query} = inputQuery;

    if (isEmpty(query)) {
        return currentUrl;
    }

    const search = queryString.stringify(query); // query may have undefined values & returns empty string
    if (search === "") {
        return currentUrl;
    }

    // append query string to currentUrl
    return currentUrl.indexOf("?") === -1 ? `${currentUrl}?${search}` : `${currentUrl}&${search}`;
};

const isEmpty = (obj: Record<string, unknown>) => Object.keys(obj).length === 0 && obj.constructor === Object;
